import React, { useState, useEffect } from "react";
import Card from "react-bootstrap/Card";
import Sidebar from "./../components/sidebar";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Alert from "react-bootstrap/Alert";
import Spinner from "react-bootstrap/Spinner";
import Pagination from "react-bootstrap/Pagination";
import axios from "axios";
import Image from "react-bootstrap/Image";

const Cursos = () => {
  // Estado para los cursos y módulos
  const [cursos, setCursos] = useState([]);
  const [modulos, setModulos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Estados para el modal de edición
  const [showEditModal, setShowEditModal] = useState(false);
  const [currentCurso, setCurrentCurso] = useState(null);
  const [editForm, setEditForm] = useState({
    nombrecurso: "",
    descripcion: "",
    materiales: "",
    ejercicios: "",
    categoria: "",
  });
  const [editErrors, setEditErrors] = useState({});
  const [editSuccess, setEditSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Estados para el modal de añadir lección
  const [showAddLeccionModal, setShowAddLeccionModal] = useState(false);
  const [leccionForm, setLeccionForm] = useState({
    titulo: "",
    contenido: "",
    videoUrl: "",
    duracion: "",
    cursoId: null,
    moduloId: "",
  });
  const [leccionSuccess, setLeccionSuccess] = useState(false);
  const [leccionError, setLeccionError] = useState(null);
  const [leccionLoading, setLeccionLoading] = useState(false);

  // Estados para el modal de añadir módulo
  const [showAddModuloModal, setShowAddModuloModal] = useState(false);
  const [moduloForm, setModuloForm] = useState({
    nombremodulo: "",
    descripcionmodulo: "",
    cursoId: null,
    nombrecurso: ""
  });
  const [moduloSuccess, setModuloSuccess] = useState(false);
  const [moduloError, setModuloError] = useState(null);
  const [moduloLoading, setModuloLoading] = useState(false);

  // Estado para confirmación de eliminación
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [cursoToDelete, setCursoToDelete] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [deleteError, setDeleteError] = useState(null);

  // Estados para paginación
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // Cargar cursos y módulos desde la API
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [cursosResponse, modulosResponse] = await Promise.all([
          axios.get("https://api.mrcirp.com/public/cursos"),
          axios.get("https://api.mrcirp.com/public/modulos")
        ]);
        
        setCursos(cursosResponse.data);
        setModulos(modulosResponse.data);
      } catch (err) {
        setError(err.response?.data?.message || "Error al cargar los datos");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Función para obtener módulos de un curso específico
  const getModulosByCurso = (cursoId) => {
    return modulos.filter(modulo => modulo.idcurso == cursoId);
  };

  // Funciones para paginación
  const totalPages = Math.ceil(cursos.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentCursos = cursos.slice(startIndex, endIndex);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Manejar edición de curso
  const handleEdit = (curso) => {
    setCurrentCurso(curso);
    setEditForm({
      nombrecurso: curso.nombrecurso,
      descripcion: curso.descripcion,
      materiales: curso.materiales || "",
      ejercicios: curso.ejercicios || "",
      categoria: curso.categoria || "",
    });
    setShowEditModal(true);
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validateEditForm = () => {
    const newErrors = {};
    if (!editForm.nombrecurso.trim())
      newErrors.nombrecurso = "El nombre del curso es requerido";
    if (!editForm.descripcion.trim())
      newErrors.descripcion = "La descripción es requerida";

    setEditErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    if (!validateEditForm()) return;

    setIsSubmitting(true);
    try {
      const response = await axios.put(
        `https://api.mrcirp.com/public/actualizarcurso/${currentCurso.id}`,
        {
          nombrecurso: editForm.nombrecurso,
          descripcion: editForm.descripcion,
          materiales: editForm.materiales,
          ejercicios: editForm.ejercicios,
          categoria: editForm.categoria,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const updatedCursos = cursos.map((curso) =>
        curso.id === currentCurso.id ? response.data.curso : curso
      );
      setCursos(updatedCursos);
      setEditSuccess(true);
      
      setTimeout(() => {
        setShowEditModal(false);
        setEditSuccess(false);
      }, 1500);
    } catch (err) {
      console.error("Error en la solicitud:", err);
      setError(err.response?.data?.message || "Error al actualizar el curso");
    } finally {
      setIsSubmitting(false);
    }
  };

  // Manejar añadir lección
  const handleAddLeccion = (cursoId) => {
    setLeccionForm({
      titulo: "",
      contenido: "",
      videoUrl: "",
      duracion: "",
      cursoId,
      moduloId: "",
    });
    setLeccionError(null);
    setLeccionSuccess(false);
    setShowAddLeccionModal(true);
  };

  const handleLeccionChange = (e) => {
    const { name, value } = e.target;
    setLeccionForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

 const handleLeccionSubmit = async (e) => {
  e.preventDefault();
  setLeccionLoading(true);
  
  try {
    if (!leccionForm.titulo.trim() || !leccionForm.contenido.trim()) {
      throw new Error("Título y contenido son campos requeridos");
    }

    if (!leccionForm.moduloId) {
      throw new Error("Debes seleccionar un módulo");
    }

    const curso = cursos.find(c => c.id === leccionForm.cursoId);
    const moduloSeleccionado = modulos.find(m => m.id == leccionForm.moduloId);
    
    if (!curso || !moduloSeleccionado) {
      throw new Error("No se encontró el curso o módulo seleccionado");
    }

    const requestData = {
      titulo: leccionForm.titulo,
      contenido: leccionForm.contenido,
      videoUrl: leccionForm.videoUrl,
      duracion: leccionForm.duracion,
      cursoId: leccionForm.cursoId,
      modulo: leccionForm.moduloId,
      nombreModulo: moduloSeleccionado.nombremodulo, // Añadimos el nombre del módulo
      nombreCurso: curso.nombrecurso
    };

    const response = await axios.post(
      "https://api.mrcirp.com/public/lecciones",
      requestData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    console.log(response.data);

    setLeccionSuccess(true);
    setTimeout(() => {
      setShowAddLeccionModal(false);
      setLeccionSuccess(false);
    }, 1500);
  } catch (err) {
    console.error("Error al guardar la lección:", err);
    setLeccionError(err.response?.data?.message || err.message || "Error al guardar la lección");
  } finally {
    setLeccionLoading(false);
  }
};

  // Manejar añadir módulo
  const handleAddModulo = (cursoId) => {
    const curso = cursos.find(c => c.id === cursoId);
    setModuloForm({
      nombremodulo: "",
      descripcionmodulo: "",
      cursoId,
      nombrecurso: curso?.nombrecurso || ""
    });
    setModuloError(null);
    setModuloSuccess(false);
    setShowAddModuloModal(true);
  };

  const handleModuloChange = (e) => {
    const { name, value } = e.target;
    setModuloForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleModuloSubmit = async (e) => {
    e.preventDefault();
    setModuloLoading(true);
    
    try {
      if (!moduloForm.nombremodulo.trim()) {
        throw new Error("El nombre del módulo es requerido");
      }

      const requestData = {
        nombremodulo: moduloForm.nombremodulo,
        descripcionmodulo: moduloForm.descripcionmodulo,
        idcurso: moduloForm.cursoId,
        nombrecurso: moduloForm.nombrecurso
      };

      const response = await axios.post(
        "https://api.mrcirp.com/public/modulos",
        requestData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log(response.data);

      // Actualizar la lista de módulos después de añadir uno nuevo
      const modulosResponse = await axios.get("https://api.mrcirp.com/public/modulos");
      setModulos(modulosResponse.data);

      setModuloSuccess(true);
      setTimeout(() => {
        setShowAddModuloModal(false);
        setModuloSuccess(false);
      }, 1500);
    } catch (err) {
      console.error("Error al guardar el módulo:", err);
      setModuloError(err.response?.data?.message || err.message || "Error al guardar el módulo");
    } finally {
      setModuloLoading(false);
    }
  };

  // Manejar eliminación de curso
  const handleDeleteClick = (curso) => {
    setCursoToDelete(curso);
    setShowDeleteModal(true);
  };

  const handleDeleteConfirm = async () => {
    if (!cursoToDelete) return;
    
    setDeleteLoading(true);
    setDeleteError(null);
    
    try {
      await axios.delete(
        `https://api.mrcirp.com/public/cursos/${cursoToDelete.id}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      
      const updatedCursos = cursos.filter(curso => curso.id !== cursoToDelete.id);
      setCursos(updatedCursos);
      
      // Ajustar la página actual si es necesario
      const newTotalPages = Math.ceil(updatedCursos.length / itemsPerPage);
      if (currentPage > newTotalPages && newTotalPages > 0) {
        setCurrentPage(newTotalPages);
      }
      
      setShowDeleteModal(false);
    } catch (err) {
      console.error("Error al eliminar el curso:", err);
      setDeleteError(err.response?.data?.message || "Error al eliminar el curso");
    } finally {
      setDeleteLoading(false);
    }
  };

  if (loading) {
    return (
      <Sidebar>
        <div className="container mt-4 text-center">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Cargando...</span>
          </Spinner>
          <p>Cargando cursos...</p>
        </div>
      </Sidebar>
    );
  }

  if (error) {
    return (
      <Sidebar>
        <div className="container mt-4">
          <Alert variant="danger">{error}</Alert>
        </div>
      </Sidebar>
    );
  }

  return (
    <div>
      <Sidebar>
        <div className="container mt-4">
          <Row>
            <Col>
              <Card>
                <Card.Header as="h5" className="d-flex justify-content-between align-items-center">
                  <span>Lista de Cursos</span>
                  <small className="text-muted">
                    Mostrando {currentCursos.length} de {cursos.length} cursos
                  </small>
                </Card.Header>
                <Card.Body style={{ padding: '0.75rem' }}>
                  {cursos.length === 0 ? (
                    <Alert variant="info" className="mb-0">No hay cursos disponibles</Alert>
                  ) : (
                    <>
                      <div className="table-responsive" style={{ fontSize: '0.875rem' }}>
                        <Table striped bordered hover size="sm" className="mb-2">
                          <thead>
                            <tr>
                              <th style={{ width: '50px', padding: '0.5rem' }}>#</th>
                              <th style={{ padding: '0.5rem' }}>Nombre del Curso</th>
                              <th style={{ padding: '0.5rem', maxWidth: '300px' }}>Descripción</th>
                              <th style={{ width: '100px', padding: '0.5rem' }}>Categoría</th>
                              <th style={{ width: '80px', padding: '0.5rem' }}>Imagen</th>
                              <th style={{ width: '320px', padding: '0.5rem' }}>Acciones</th>
                            </tr>
                          </thead>
                          <tbody>
                            {currentCursos.map((curso, index) => (
                              <tr key={curso.id}>
                                <td style={{ padding: '0.5rem', textAlign: 'center' }}>
                                  {startIndex + index + 1}
                                </td>
                                <td style={{ padding: '0.5rem', fontWeight: '500' }}>
                                  {curso.nombrecurso}
                                </td>
                                <td style={{ padding: '0.5rem' }}>
                                  <div style={{ 
                                    maxWidth: '300px', 
                                    overflow: 'hidden', 
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap'
                                  }} title={curso.descripcion}>
                                    {curso.descripcion}
                                  </div>
                                </td>
                                <td style={{ padding: '0.5rem', textAlign: 'center' }}>
                                  <span style={{ 
                                    fontSize: '0.75rem',
                                    padding: '0.25rem 0.5rem',
                                    borderRadius: '4px',
                                    backgroundColor: curso.categoria === 'academia' ? '#e3f2fd' : 
                                                   curso.categoria === 'mentoria' ? '#f3e5f5' : 
                                                   curso.categoria === 'certificacion' ? '#e8f5e9' : '#f5f5f5',
                                    color: curso.categoria === 'academia' ? '#1976d2' : 
                                           curso.categoria === 'mentoria' ? '#7b1fa2' : 
                                           curso.categoria === 'certificacion' ? '#388e3c' : '#757575',
                                    textTransform: 'capitalize'
                                  }}>
                                    {curso.categoria || '-'}
                                  </span>
                                </td>
                                <td style={{ padding: '0.5rem', textAlign: 'center' }}>
                                  {curso.imagen && (
                                    <Image
                                      src={curso.imagen}
                                      alt={curso.nombrecurso}
                                      thumbnail
                                      style={{ maxWidth: "60px", maxHeight: "60px", objectFit: 'cover' }}
                                    />
                                  )}
                                </td>
                                <td style={{ padding: '0.5rem' }}>
                                  <div className="d-flex flex-wrap gap-1">
                                    <Button
                                      variant="warning"
                                      size="sm"
                                      onClick={() => handleEdit(curso)}
                                      style={{ fontSize: '0.75rem', padding: '0.25rem 0.5rem' }}
                                    >
                                      Editar
                                    </Button>
                                    <Button
                                      variant="info"
                                      size="sm"
                                      onClick={() => handleAddModulo(curso.id)}
                                      style={{ fontSize: '0.75rem', padding: '0.25rem 0.5rem' }}
                                    >
                                      Módulo
                                    </Button>
                                    <Button
                                      variant="success"
                                      size="sm"
                                      onClick={() => handleAddLeccion(curso.id)}
                                      style={{ fontSize: '0.75rem', padding: '0.25rem 0.5rem' }}
                                    >
                                      Lección
                                    </Button>
                                    <Button
                                      variant="danger"
                                      size="sm"
                                      onClick={() => handleDeleteClick(curso)}
                                      style={{ fontSize: '0.75rem', padding: '0.25rem 0.5rem' }}
                                    >
                                      Eliminar
                                    </Button>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                      
                      {totalPages > 1 && (
                        <div className="d-flex justify-content-center mt-3">
                          <Pagination>
                            <Pagination.First 
                              onClick={() => handlePageChange(1)} 
                              disabled={currentPage === 1}
                            />
                            <Pagination.Prev 
                              onClick={() => handlePageChange(currentPage - 1)} 
                              disabled={currentPage === 1}
                            />
                            {[...Array(totalPages)].map((_, index) => {
                              const page = index + 1;
                              // Mostrar solo algunas páginas alrededor de la actual
                              if (
                                page === 1 ||
                                page === totalPages ||
                                (page >= currentPage - 2 && page <= currentPage + 2)
                              ) {
                                return (
                                  <Pagination.Item
                                    key={page}
                                    active={page === currentPage}
                                    onClick={() => handlePageChange(page)}
                                  >
                                    {page}
                                  </Pagination.Item>
                                );
                              } else if (
                                page === currentPage - 3 ||
                                page === currentPage + 3
                              ) {
                                return <Pagination.Ellipsis key={page} />;
                              }
                              return null;
                            })}
                            <Pagination.Next 
                              onClick={() => handlePageChange(currentPage + 1)} 
                              disabled={currentPage === totalPages}
                            />
                            <Pagination.Last 
                              onClick={() => handlePageChange(totalPages)} 
                              disabled={currentPage === totalPages}
                            />
                          </Pagination>
                        </div>
                      )}
                    </>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>
      </Sidebar>

      {/* Modal de Edición */}
      <Modal
        show={showEditModal}
        onHide={() => setShowEditModal(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Editar Curso</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {editSuccess && (
            <Alert variant="success">Cambios guardados correctamente!</Alert>
          )}
          <Form onSubmit={handleEditSubmit}>
            <Form.Group className="mb-3" controlId="editNombrecurso">
              <Form.Label>Nombre del Curso *</Form.Label>
              <Form.Control
                type="text"
                name="nombrecurso"
                value={editForm.nombrecurso}
                onChange={handleEditChange}
                isInvalid={!!editErrors.nombrecurso}
              />
              <Form.Control.Feedback type="invalid">
                {editErrors.nombrecurso}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId="editDescripcion">
              <Form.Label>Descripción *</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="descripcion"
                value={editForm.descripcion}
                onChange={handleEditChange}
                isInvalid={!!editErrors.descripcion}
              />
              <Form.Control.Feedback type="invalid">
                {editErrors.descripcion}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId="editMateriales">
              <Form.Label>Materiales</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="materiales"
                value={editForm.materiales}
                onChange={handleEditChange}
                isInvalid={!!editErrors.materiales}
              />
              <Form.Control.Feedback type="invalid">
                {editErrors.materiales}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId="editEjercicios">
              <Form.Label>Ejercicios</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="ejercicios"
                value={editForm.ejercicios}
                onChange={handleEditChange}
                isInvalid={!!editErrors.ejercicios}
              />
              <Form.Control.Feedback type="invalid">
                {editErrors.ejercicios}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId="editCategoria">
              <Form.Label>Categoría</Form.Label>
              <Form.Select
                name="categoria"
                value={editForm.categoria}
                onChange={handleEditChange}
                isInvalid={!!editErrors.categoria}
              >
                <option value="">Selecciona una categoría</option>
                <option value="academia">Academia</option>
                <option value="mentoria">Mentoría</option>
                <option value="certificacion">Certificación</option>
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {editErrors.categoria}
              </Form.Control.Feedback>
            </Form.Group>

            <div className="d-grid gap-2">
              <Button variant="primary" type="submit" disabled={isSubmitting}>
                {isSubmitting ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                    {" Guardando..."}
                  </>
                ) : (
                  "Guardar Cambios"
                )}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Modal para Añadir Lección */}
      <Modal
        show={showAddLeccionModal}
        onHide={() => setShowAddLeccionModal(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Añadir Nueva Lección</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {leccionSuccess && (
            <Alert variant="success">Lección guardada correctamente!</Alert>
          )}
          {leccionError && (
            <Alert variant="danger">{leccionError}</Alert>
          )}
          <Form onSubmit={handleLeccionSubmit}>
            <Form.Group className="mb-3" controlId="leccionModulo">
              <Form.Label>Módulo *</Form.Label>
              <Form.Select
                name="moduloId"
                value={leccionForm.moduloId}
                onChange={handleLeccionChange}
                required
              >
                <option value="">Selecciona un módulo</option>
                {leccionForm.cursoId && getModulosByCurso(leccionForm.cursoId).map(modulo => (
                  <option key={modulo.id} value={modulo.id}>
                    {modulo.nombremodulo}
                  </option>
                ))}
              </Form.Select>
              {!leccionForm.moduloId && leccionError?.includes("módulo") && (
                <Form.Text className="text-danger">
                  Debes seleccionar un módulo
                </Form.Text>
              )}
            </Form.Group>

            <Form.Group className="mb-3" controlId="leccionTitulo">
              <Form.Label>Título de la Lección *</Form.Label>
              <Form.Control
                type="text"
                name="titulo"
                value={leccionForm.titulo}
                onChange={handleLeccionChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="leccionContenido">
              <Form.Label>Contenido *</Form.Label>
              <Form.Control
                as="textarea"
                rows={5}
                name="contenido"
                value={leccionForm.contenido}
                onChange={handleLeccionChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="leccionVideoUrl">
              <Form.Label>URL del Video</Form.Label>
              <Form.Control
                type="url"
                name="videoUrl"
                value={leccionForm.videoUrl}
                onChange={handleLeccionChange}
                placeholder="https://ejemplo.com/video"
              />
              <Form.Text className="text-muted">
                Ingresa la URL completa del video (YouTube, Vimeo, etc.)
              </Form.Text>
            </Form.Group>

            <Form.Group className="mb-3" controlId="leccionduracion">
              <Form.Label>Duración</Form.Label>
              <Form.Control
                type="text"
                name="duracion"
                value={leccionForm.duracion}
                onChange={handleLeccionChange}
                placeholder="00:00:00"
              />
              <Form.Text className="text-muted">
                Ingresa la duración del video
              </Form.Text>
            </Form.Group>

            <div className="d-grid gap-2">
              <Button variant="success" type="submit" disabled={leccionLoading}>
                {leccionLoading ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                    {" Guardando..."}
                  </>
                ) : (
                  "Guardar Lección"
                )}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Modal para Añadir Módulo */}
      <Modal
        show={showAddModuloModal}
        onHide={() => setShowAddModuloModal(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Añadir Nuevo Módulo</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {moduloSuccess && (
            <Alert variant="success">Módulo guardado correctamente!</Alert>
          )}
          {moduloError && (
            <Alert variant="danger">{moduloError}</Alert>
          )}
          <Form onSubmit={handleModuloSubmit}>
            <Form.Group className="mb-3" controlId="moduloTitulo">
              <Form.Label>Nombre del Módulo *</Form.Label>
              <Form.Control
                type="text"
                name="nombremodulo"
                value={moduloForm.nombremodulo}
                onChange={handleModuloChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="moduloDescripcion">
              <Form.Label>Descripción</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="descripcionmodulo"
                value={moduloForm.descripcionmodulo}
                onChange={handleModuloChange}
              />
            </Form.Group>

            <div className="d-grid gap-2">
              <Button variant="info" type="submit" disabled={moduloLoading}>
                {moduloLoading ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                    {" Guardando..."}
                  </>
                ) : (
                  "Guardar Módulo"
                )}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Modal de Confirmación de Eliminación */}
      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirmar Eliminación</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {deleteError && <Alert variant="danger">{deleteError}</Alert>}
          <p>
            ¿Estás seguro que deseas eliminar el curso "{cursoToDelete?.nombrecurso}"?
            Esta acción no se puede deshacer.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowDeleteModal(false)}
            disabled={deleteLoading}
          >
            Cancelar
          </Button>
          <Button
            variant="danger"
            onClick={handleDeleteConfirm}
            disabled={deleteLoading}
          >
            {deleteLoading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
                {" Eliminando..."}
              </>
            ) : (
              "Eliminar"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Cursos;